(() => {
  const hero = document.querySelector('[data-jillleen-hero]');

  if (!hero || hero.dataset.jillleenReady === 'true') return;

  const slides = Array.from(hero.querySelectorAll('[data-jillleen-slide]'));
  const dots = Array.from(hero.querySelectorAll('[data-jillleen-hero-dot]'));
  const previous = hero.querySelector('[data-jillleen-hero-prev]');
  const next = hero.querySelector('[data-jillleen-hero-next]');
  const status = hero.querySelector('[data-jillleen-hero-status]');
  const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
  const autoplayEnabled = hero.dataset.jillleenHeroAutoplay !== 'false';
  const requestedInterval = Number(hero.dataset.jillleenHeroInterval || 6000);
  const autoplayInterval = Math.max(5000, Number.isFinite(requestedInterval) ? requestedInterval : 6000);
  let activeIndex = 0;
  let pointerStartX = null;
  let autoplayTimer = null;
  let pointerIsInside = false;
  let focusIsInside = false;

  if (slides.length < 2) return;

  hero.dataset.jillleenReady = 'true';
  hero.dataset.jillleenHeroIntervalEffective = String(autoplayInterval);

  const showSlide = (requestedIndex) => {
    activeIndex = (requestedIndex + slides.length) % slides.length;
    hero.dataset.jillleenActiveIndex = String(activeIndex);

    slides.forEach((slide, index) => {
      const isActive = index === activeIndex;
      slide.classList.toggle('is-active', isActive);
      slide.setAttribute('aria-hidden', String(!isActive));
    });

    dots.forEach((dot, index) => {
      const isActive = index === activeIndex;
      dot.classList.toggle('is-active', isActive);
      dot.setAttribute('aria-selected', String(isActive));
    });

    if (status) status.textContent = `${activeIndex + 1} / ${slides.length}`;
  };

  const pauseAutoplay = () => {
    if (autoplayTimer) window.clearInterval(autoplayTimer);
    autoplayTimer = null;
    hero.dataset.jillleenAutoplayRunning = 'false';
  };

  const canAutoplay = () => (
    autoplayEnabled &&
    !reducedMotion.matches &&
    !document.hidden &&
    !pointerIsInside &&
    !focusIsInside
  );

  const startAutoplay = () => {
    pauseAutoplay();
    if (!canAutoplay()) return;

    autoplayTimer = window.setInterval(() => {
      showSlide(activeIndex + 1);
    }, autoplayInterval);
    hero.dataset.jillleenAutoplayRunning = 'true';
  };

  const showManualSlide = (requestedIndex) => {
    showSlide(requestedIndex);
    startAutoplay();
  };

  previous?.addEventListener('click', () => showManualSlide(activeIndex - 1));
  next?.addEventListener('click', () => showManualSlide(activeIndex + 1));

  dots.forEach((dot) => {
    dot.addEventListener('click', () => {
      showManualSlide(Number(dot.dataset.jillleenHeroDot));
    });
  });

  hero.addEventListener('keydown', (event) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      showManualSlide(activeIndex - 1);
    }

    if (event.key === 'ArrowRight') {
      event.preventDefault();
      showManualSlide(activeIndex + 1);
    }
  });

  hero.addEventListener('pointerdown', (event) => {
    if (event.pointerType === 'mouse' && event.button !== 0) return;
    pointerStartX = event.clientX;
  });

  hero.addEventListener('pointerup', (event) => {
    if (pointerStartX === null) return;

    const distance = event.clientX - pointerStartX;
    pointerStartX = null;

    if (Math.abs(distance) < 48) return;
    showManualSlide(activeIndex + (distance < 0 ? 1 : -1));
  });

  hero.addEventListener('pointercancel', () => {
    pointerStartX = null;
  });

  hero.addEventListener('pointerenter', () => {
    pointerIsInside = true;
    pauseAutoplay();
  });

  hero.addEventListener('pointerleave', () => {
    pointerIsInside = false;
    startAutoplay();
  });

  hero.addEventListener('focusin', () => {
    focusIsInside = true;
    pauseAutoplay();
  });

  hero.addEventListener('focusout', (event) => {
    if (event.relatedTarget && hero.contains(event.relatedTarget)) return;
    focusIsInside = false;
    startAutoplay();
  });

  document.addEventListener('visibilitychange', startAutoplay);
  reducedMotion.addEventListener?.('change', startAutoplay);

  showSlide(activeIndex);
  startAutoplay();
})();

(() => {
  if (!document.body.classList.contains('template-index')) return;

  const modal = document.getElementById('NewsletterModal');
  const trigger = document.querySelector('[data-modal-newsletter]');

  if (!modal || modal.dataset.jillleenPhase0Ready === 'true') return;

  modal.dataset.jillleenPhase0Ready = 'true';
  modal.dataset.delay = '45000';
  modal.dataset.expire = '30';

  const dismissedKey = 'jillleenNewsletterDismissedAt';
  const subscribedKey = 'jillleenNewsletterSubscribed';
  const thirtyDays = 30 * 24 * 60 * 60 * 1000;
  let delayPassed = false;
  let engaged = false;
  let autoOpened = false;

  const readStorage = (key) => {
    try {
      return window.localStorage.getItem(key);
    } catch (error) {
      return null;
    }
  };

  const writeStorage = (key, value) => {
    try {
      window.localStorage.setItem(key, value);
    } catch (error) {
      // Storage can be unavailable in private browsing; the dialog still works.
    }
  };

  const setSuppressionCookie = () => {
    document.cookie = 'emailSubcribeModal=closed; max-age=2592000; path=/; SameSite=Lax';
  };

  const clearSuppressionCookie = () => {
    document.cookie = 'emailSubcribeModal=; max-age=0; path=/; SameSite=Lax';
  };

  const dismissedAt = Number(readStorage(dismissedKey) || 0);
  const isSubscribed = readStorage(subscribedKey) === 'true';
  const canAutoOpen = !isSubscribed && (!dismissedAt || Date.now() - dismissedAt >= thirtyDays);

  setSuppressionCookie();

  const permitDialog = () => {
    document.body.classList.add('jillleen-newsletter-eligible');
    clearSuppressionCookie();
  };

  const openAutomatically = () => {
    if (!canAutoOpen || autoOpened || !delayPassed || !engaged || !trigger) return;

    autoOpened = true;
    permitDialog();
    trigger.click();
  };

  const markEngaged = () => {
    engaged = true;
    openAutomatically();
  };

  const onScroll = () => {
    const scrollable = document.documentElement.scrollHeight - window.innerHeight;
    if (scrollable <= 0 || window.scrollY / scrollable < 0.18) return;

    window.removeEventListener('scroll', onScroll);
    markEngaged();
  };

  window.addEventListener('scroll', onScroll, { passive: true });
  document.addEventListener('pointerdown', markEngaged, { once: true, passive: true });

  window.setTimeout(() => {
    delayPassed = true;
    openAutomatically();
  }, 45000);

  const permitManualOpen = () => {
    permitDialog();
  };

  trigger?.addEventListener('pointerdown', permitManualOpen, { capture: true, passive: true });
  trigger?.addEventListener('keydown', (event) => {
    if (event.key === 'Enter' || event.key === ' ') permitManualOpen();
  }, true);

  const closeButton = modal.querySelector('.close-window');
  closeButton?.addEventListener('click', () => {
    writeStorage(dismissedKey, String(Date.now()));
    setSuppressionCookie();

    window.setTimeout(() => {
      document.body.classList.remove('jillleen-newsletter-eligible');
    }, 1100);
  });

  const form = modal.querySelector('form');
  form?.addEventListener('submit', () => {
    writeStorage(subscribedKey, 'true');
    writeStorage(dismissedKey, String(Date.now()));
    setSuppressionCookie();
  });
})();
